import { isMobile, removeUndefineds } from './index'; //import { getResolution } from '../../state/settings/renderDimensions';

export default function generateConnectionOptions(userOptions) {
  // in the future we can pass settings object to this function and generate twilio connection options.
  // right now only for defaults
  // See: https://media.twiliocdn.com/sdk/js/video/releases/2.0.0/docs/global.html#ConnectOptions
  // for available connection options.
  var defaultOptions = {
    /* Shai: all these settings are not reelvant for P2P rooms 
      // Bandwidth Profile, Dominant Speaker, and Network Quality
    // features are only available in Small Group or Group Rooms.
    // Please set "Room Type" to "Group" or "Small Group" in your
    // Twilio Console: https://www.twilio.com/console/video/configure
    bandwidthProfile: {
      video: {
        mode: settings.bandwidthProfileMode,
        dominantSpeakerPriority: settings.dominantSpeakerPriority,
        renderDimensions: {
          low: getResolution(settings.renderDimensionLow),
          standard: getResolution(settings.renderDimensionStandard),
          high: getResolution(settings.renderDimensionHigh),
        },
        maxTracks: Number(settings.maxTracks),
      },
    },
    dominantSpeaker: true,
    networkQuality: { local: 1, remote: 1 },
      // VP8 simulcast enables the media server in a Small Group or Group Room
    // to adapt your encoded video quality for each RemoteParticipant based on
    // their individual bandwidth constraints. This has no effect if you are
    // using Peer-to-Peer Rooms.
    preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
      */
    maxAudioBitrate: 16000,
    // Comment this line if you are playing music.
    maxVideoBitrate: isMobile ? 2500000 : undefined
  }; // For mobile browsers, limit the maximum incoming video bitrate to 2.5 Mbps.

  if (isMobile && defaultOptions.bandwidthProfile && defaultOptions.bandwidthProfile.video) {
    defaultOptions.bandwidthProfile.video.maxSubscriptionBitrate = 2500000;
  } // TODO: need deep cloning assign instead of simple one


  var connectionOptions = Object.assign({}, defaultOptions, userOptions); // Here we remove any 'undefined' values. The twilio-video SDK will only use defaults
  // when no value is passed for an option. It will throw an error when 'undefined' is passed.

  return removeUndefineds(connectionOptions);
}